import { render, staticRenderFns } from "./EditProducer.vue?vue&type=template&id=170f733d&scoped=true&"
import script from "./EditProducer.vue?vue&type=script&lang=js&"
export * from "./EditProducer.vue?vue&type=script&lang=js&"
import style0 from "./EditProducer.vue?vue&type=style&index=0&id=170f733d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170f733d",
  null
  
)

export default component.exports